module.exports = __webpack_public_path__ + "img/hourglass-dent-red.17d936af.svg";